/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_Active_CategoryInputs */

const en_directory_launch_active_category = /** @type {(inputs: Directory_Launch_Active_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most active category`)
};

const zh_directory_launch_active_category = /** @type {(inputs: Directory_Launch_Active_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最活跃分类`)
};

/**
* | output |
* | --- |
* | "Most active category" |
*
* @param {Directory_Launch_Active_CategoryInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_active_category = /** @type {((inputs?: Directory_Launch_Active_CategoryInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_Active_CategoryInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_active_category(inputs)
	return zh_directory_launch_active_category(inputs)
});
export { directory_launch_active_category as "directory.launch.active_category" }